import { useContext, useEffect, useState } from "react";
import { getHouseMainWidget } from "./house-service";
import { HouseMainWidget, HouseWidget } from "./types";
import Button from "../../../components/Button/button";
import { HouseCompetitionData } from "./contextProvider";
import Skeleton from "react-loading-skeleton";
import TicketModalPopup from "../../../components/PrizeTicketSelector/prizeTicketSelector";
import { useAppDispatch } from "../../../redux/hooks";
import {
  publishModalClasses,
  publishModalData,
  publishModalVisibility,
} from "../../../redux/features/modal/modalSlice";
import DOMPurify from "dompurify";

const Widget = () => {
  const { prizeId, currencySymbol, activePriceWithoutCurrency, isPrizeAvailable } = useContext(HouseCompetitionData);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (prizeId) {
      getWidgets();
    }
  }, [prizeId]);

  const [widgetData, setWidgetData] = useState<HouseMainWidget>();
  const getWidgets = async () => {
    try {
      const response = await getHouseMainWidget(prizeId);
      const { HouseMainWidget } = (await response.json()) as HouseWidget;
      setWidgetData(HouseMainWidget);
    } catch (error) {
      console.error("Error fetching widgets:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getModalPopupContent = () => {
    dispatch(
      publishModalData({
        modalData: <TicketModalPopup {...{ prizeId }} />,
      })
    );
    dispatch(
      publishModalClasses({
        classNames: "md:rounded-2xl xs:absolute xs:bottom-0 xs:w-full xs:rounded-b-none xs:rounded-t-2xl z-10",
      })
    );
    dispatch(publishModalVisibility({ isOpen: true }));
  };

  const onAddWidgetToBasket = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    getModalPopupContent();
  };

  const housePrizePrice = `${currencySymbol}${activePriceWithoutCurrency}`;

  return isLoading ? (
    <Skeleton inline highlightColor="#fff" height={300} containerClassName="w-full bg-[#f1f1f1]" />
  ) : (
    <div className={`bg-[#F5F5F5] rounded-lg flex flex-col relative lg:p-8`}>
      <span
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(widgetData?.Title),
        }}
        className="absolute top-0 left-0"
      />
      <div className="xs:flex justify-between items-center lg:flex-row xs:flex-col">
        <div className="xs:p-6 flex xs:mt-4 lg:mt-0 justify-center flex-grow">
          {widgetData?.Images.map((item, index) => (
            <div key={item.Text} className="flex items-center">
              <div className="flex flex-col text-center items-center">
                <img src={item.Image} alt={item.Text} className="lg:h-[97px] lg:w-[160px] xs:h-[53px] xs:w-[88px]" />
                <span className="text-[#4C4C52] font-jost lg:text-[16.5px] xs:text-[11px] font-medium mt-3 lg:leading-[21px] xs:leading-[14px]">
                  {item.Text}
                </span>
              </div>
              {index < widgetData?.Images?.length - 1 && (
                <span className="text-[#323232] lg:mx-5 xs:mx-3">{`${widgetData.Separator !== undefined && widgetData.Separator !== null && widgetData.Separator !== "" ? widgetData.Separator : "+"}`}</span>
              )}
            </div>
          ))}
        </div>
        <div className="flex xs:w-full lg:w-auto lg:flex-col xs:justify-between lg:justify-normal lg:gap-2 font-jost xs:bg-[#E7E7E9] lg:bg-[#F5F5F5] xs:p-2 items-center lg:rounded-none xs:rounded-b-lg">
          <div className="flex gap-1 lg:self-start">
            <span className="text-[#4C4C52] lg:text-[16px] xs:text-[14px] font-medium whitespace-nowrap">
              For only:
            </span>
            <span className="text-[#28282B] lg:text-[24px] xs:text-[18px] font-bold lg:leading-[1] xs:leading-6 whitespace-nowrap">
              {housePrizePrice}🎉
            </span>
          </div>
          <Button
            className="font-jost uppercase flex items-center text-white bg-[#6679B3] rounded w-fit btnWithArrow font-medium"
            onClick={onAddWidgetToBasket}
            isDisabled={!isPrizeAvailable}
            text="">
            <span className="lg:pr-[49px] lg:pl-[31px] lg:py-[10px] xs:py-1 xs:pl-[13px] xs:pr-[24px] flex relative justify-center items-center whitespace-nowrap">
              <span className="lg:text-[14px] xs:text-[12px]">Add to basket</span>
              <img
                className="arrowImage absolute lg:left-[76%] xs:right-[14px] lg:w-[10px] xs:w-[7px] lg:h-[10px] xs:h-[7px]"
                src="/assets/images/chevron.png"
                alt="add-to-basket-button-arrow"
              />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Widget;
